import React, { Component } from 'react';
import {
  Alert, Button, Spinner, Table,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from './Form';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { NewsLetterAPI } from "../../API";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import { exportToExcel } from 'Utils/ExportToExcel';
import { formatSmartDate } from "../../Utils/DateFormatter";
import { toast } from 'react-toastify';


const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
  BODY: 'BODY'
};

type State = {
  status: PageStatus,
  error: string | null,
  formType: string,
  body: string | null,
  data: any[],
  id?: string | null,
  filteredData: any[],
  filters: {
    status: '',
    rewardCoupon: '',
    rewardCorporation: '',
    rewardAssoicatedUserId: '',
  },
  pageSize: any,
  currentPageNumber: any,
  totalResponseData: any,
  totalResponsePages: any,
  cat: string,
  teampleate: string
};

class UploadCoupon extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      formType: MODAL_TYPES.NONE,
      data: [],
      id: null,
      body: null,
      filteredData: [],
      filters: {
        status: '',
        rewardCoupon: '',
        rewardCorporation: '',
        rewardAssoicatedUserId: '',
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalResponseData: '',
      totalResponsePages: '',
      showTempleteModal: false,
      name: '',
      description: '',
      cat: '',
      teampleate: ''
    };
    this.fetchList = this.fetchList.bind(this);
  }

  componentDidMount() {
    this.fetchList()
  }

  fetchList(): Promise<void> {
    const { pageSize, currentPageNumber, filters } = this.state;
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => NewsLetterAPI.getallrewards(pageSize, currentPageNumber, filters))
      .then((countries) => {
        let responseData: any = countries;
        this.setState({ data: responseData.data, filteredData: responseData.data, totalResponseData: responseData.totalCount, totalResponsePages: responseData.totalPage, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  applyFilters = () => {
    if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
    this.setState({ currentPageNumber: 1 })
  };

  async handleExport() {
    const { currentPageNumber, filters } = this.state;
    this.setState({ status: PageStatus.Loading });
    try {
        const responseData: any = await NewsLetterAPI.getallrewards("All", currentPageNumber, filters, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([responseData]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Partnership_Coupons_Data.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.setState({ status: PageStatus.Loaded });
    } catch (error: any) {
        console.error("Error exporting data:", error);
        this.setState({ error: error.message, status: PageStatus.Error });
    }
  };

  clearFilter = async () => {
    await new Promise((resolve: any) =>
      this.setState({
        filters: {
          status: '',
          rewardCoupon: '',
          rewardCorporation: '',
          rewardAssoicatedUserId: '',
        },
        pageSize: 10,
        currentPageNumber: 1,
        totalResponseData: '',
        totalResponsePages: ''
      }, resolve));
    this.fetchList();
  }

  handleFilterChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState: State) => ({
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }));
  }

  handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
  handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

  componentDidUpdate(prevProps: {}, prevState: State) {
    if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
  };

  render() {
    const { filters, filteredData, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
    return (
      <>
        <GridContainer>
          <div className='w-100 mb-3'>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>Partnership</h4>
                <div>
                  <Button
                    onClick={() => {
                      return this.setState({
                        formType: MODAL_TYPES.CREATE,
                      });
                    }}
                    variant="primary"
                    size="sm"
                    className="mx-1"
                  >
                    <FontAwesomeIcon icon={['fas', 'upload']} className="mr-2" />
                    Upload
                  </Button>
                </div>
              </div>
            </CardHeader>
          </div>
        </GridContainer>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <div className='mb-3'>Filter</div>
          <form>
            <div className="row">
              <div className="col">
                <label htmlFor='rewardCoupon'>Reward Coupons</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="rewardCoupon"
                  value={filters.rewardCoupon}
                  onChange={this.handleFilterChange}

                />
              </div>
              <div className="col">
                <label htmlFor='status'>Status</label>
                <select
                  style={{
                    width: '100%',
                    display: 'block',
                    height: '40px',
                    lineHeight: '1.5',
                    color: '#495057',
                    backgroundColor: '#fff',
                    backgroundClip: 'padding-box',
                    border: '1px solid #ced4da',
                    borderRadius: '5px',
                    transition:
                      'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
                  }}
                  name='status'
                  id='status'
                  value={filters.status}
                  onChange={this.handleFilterChange}
                >
                  <option value=''>--Choose--</option>
                  <option value='New'>New</option>
                  <option value='Delivered'>Delivered</option>
                </select>
              </div>
              <div className="col">
                <label htmlFor='rewardCorporation'>Reward Corporation</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="rewardCorporation"
                  value={filters.rewardCorporation}
                  onChange={this.handleFilterChange}

                />
              </div>
              <div className="col">
                <label htmlFor='rewardAssoicatedUserId'>Reward Assoicated UserId</label>
                <input type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="rewardAssoicatedUserId"
                  value={filters.rewardAssoicatedUserId}
                  onChange={this.handleFilterChange}
                />
              </div>
            </div>
          </form>

          <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
            <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>Filter Surveys</button>
            <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>Export</button>
            <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>Clear Filter</button>
          </div>
        </div>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded}>
            <Show when={this.state.formType === MODAL_TYPES.CREATE}>
              <Form
                show={this.state.formType === MODAL_TYPES.CREATE}
                userId={this.props.userId}
                onClose={() => this.setState({
                  formType: MODAL_TYPES.NONE,
                })}
                onSubmit={(id) => {
                  this.fetchList();
                  this.setState({
                    formType: MODAL_TYPES.DETAILS, id: id,
                  });
                }}
              />
            </Show>

            <Show when={!this.state.filteredData.length}>
              <Alert variant="info" show={!this.state.filteredData.length}>
                No data is available
              </Alert>
            </Show>

            <Show when={!!this.state.filteredData.length}>
              <div>
                <div className='mb-2'>
                  <ShowDataAccording2PageSize
                    currentPageSize={pageSize}
                    currentPage={currentPageNumber}
                    sendPageSize={this.handlePageSizeChange}
                    showTotalData={totalResponseData}
                    sendLastPage={totalResponsePages}
                  />
                </div>
                <Table responsive size="sm" bordered>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Reference Number</th>
                      <th>Company Name</th>
                      <th>Coupon</th>
                      <th>Status</th>
                      <th>Reward Assoicated UserId</th>
                      <th>Location</th>
                      <th>Store ID</th>
                      <th>Expiry At</th>
                      <th>Delivered At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((info, index) => (
                      <tr key={info.id}>
                        <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                        <td>
                          {info.referenceNo || 'N/A'}
                        </td>
                        <td>
                          {info.rewardCorporation || 'N/A'}
                        </td>
                        <td>
                          {info.capedCoupons || 'N/A'}
                        </td>
                        <td>
                          {info.status}
                        </td>
                        <td>
                          {info.rewardAssoicatedUserId ?? "N/A"}
                        </td>
                        <td>
                          {info.loginLocation ?? "N/A"}
                        </td>
                        <td>
                          {info.loginStoreId ?? "N/A"}
                        </td>
                        <td>
                          {info.expiryAt ? formatSmartDate(info.expiryAt, false) : "N/A"}
                        </td>
                        <td>{info.deliveredAt ? formatSmartDate(info.deliveredAt, false) : "N/A"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div>
                  <PaginationNumbering
                    currentPage={currentPageNumber}
                    returnPagenumber={this.handlePageNumberChange}
                    showTotalData={totalResponseData}
                    sendLastPage={totalResponsePages}
                  />
                </div>
              </div>
            </Show>
          </Show>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.adminUser.adminUser.userId,
  };
}

const NewsLettersWithRouter = withRouter(connect(
  mapStateToProps,
)(UploadCoupon));

export { NewsLettersWithRouter as UploadCoupon };
